import { useEffect, useRef } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Terminal } from '@xterm/xterm'
import { FitAddon } from '@xterm/addon-fit'
import '@xterm/xterm/css/xterm.css'
export function TerminalPage() {
  const { id } = useParams()
  const token = localStorage.getItem('beebro.token') || ''
  const containerRef = useRef<HTMLDivElement>(null)
  const termRef = useRef<Terminal | null>(null)
  const wsRef = useRef<WebSocket | null>(null)

  useEffect(() => {
    if (!containerRef.current || !id || !token) return

    const term = new Terminal({
      cursorBlink: true,
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
      fontSize: 13,
      theme: {
        background: '#111',
        foreground: '#e5e5e5',
        cursor: '#e5e5e5',
        selectionBackground: '#264f78',
      },
      scrollback: 5000,
      convertEol: true,
    })
    termRef.current = term
    const fit = new FitAddon()
    term.loadAddon(fit)
    term.open(containerRef.current)
    fit.fit()

    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    const ws = new WebSocket(`${proto}//${window.location.host}/api/v1/nodes/${id}/terminal?token=${encodeURIComponent(token)}`)
    ws.binaryType = 'arraybuffer'
    wsRef.current = ws

    ws.onopen = () => {
      term.writeln('\x1b[90m→ подключение к SSH...\x1b[0m')
      // сообщим серверу размер
      ws.send(JSON.stringify({ resize: [term.cols, term.rows] }))
    }
    ws.onmessage = (ev) => {
      const data = ev.data instanceof ArrayBuffer ? new Uint8Array(ev.data) : new TextEncoder().encode(ev.data as string)
      term.write(data)
    }
    ws.onclose = () => { term.writeln('\r\n\x1b[91m[соединение закрыто]\x1b[0m') }
    ws.onerror = () => { term.writeln('\r\n\x1b[91m[ошибка соединения]\x1b[0m') }

    // ввод пользователя
    term.onData((data) => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({ data }))
      }
    })

    // paste (Cmd/Ctrl+V) поддержан xterm'ом автоматически через onData

    // resize
    const onResize = () => {
      fit.fit()
      if (ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({ resize: [term.cols, term.rows] }))
      }
    }
    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
      ws.close()
      term.dispose()
    }
  }, [id, token])

  return (
    <div className="h-[calc(100vh-96px)] flex flex-col">
      <div className="flex items-center gap-3 mb-3">
        <Link to={`/nodes/${id}`} className="text-[13px] text-neutral-500 hover:text-neutral-900">← Нода</Link>
        <h1 className="text-[18px] font-semibold">Терминал</h1>
        <span className="text-[12px] text-neutral-500">SSH через панель · вставка Cmd/Ctrl+V</span>
      </div>
      <div ref={containerRef} className="flex-1 rounded-md overflow-hidden border border-neutral-800 bg-black p-2" />
    </div>
  )
}
